import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  href: string;
  children: React.ReactNode;
  className?: string;
}
export function CTAButton({
  href,
  children,
  className = ''
}: CTAButtonProps) {
  return <motion.a href={href} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`inline-block bg-brand-accent hover:bg-brand-accentHover text-white font-poppins font-bold text-base md:text-lg py-3 px-6 md:px-8 rounded-full shadow-[0_0_30px_rgba(34,197,94,0.4)] animate-cta-pulse text-center uppercase tracking-wide transition-colors ${className}`} data-id="element-50">
      {children}
    </motion.a>;
}